import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { companiesApi } from '../../store/services/CompaniesService';
import MainLayout from '../../shared/components/MainLayout';
import CompanyAccordion from './CompanyAccordion';
import CompanyData from './CompanyData';
import { Flex, Spinner } from '@chakra-ui/react';
import { deliveriesApi } from '../../store/services/DeliveriesService';
import { DESC } from '../../shared/constants';
import CompanyBilling from './CompanyBilling';
import CompanyTariffPlan from './CompanyTariffPlan';
import CompanyIntegrationBindings from './CompanyAttachedRoles';
import { isValidUuid } from '../../shared/utils/utils';
import { Paths } from '../../router/routes';
import CompanyStats from './CompanyStats';

const Company: React.FC = () => {
  const { companyId } = useParams();
  const isValid = isValidUuid(companyId);

  const safeCompanyId = isValid && companyId ? companyId : '';
  const { data } = companiesApi.useGetCompanyByIdQuery(
    { companyId: safeCompanyId },
    { skip: !isValid },
  );
  const { data: deliveriesData } = deliveriesApi.useGetAllDeliveriesQuery(
    {
      sorting: 'id',
      order: DESC,
      limit: 0,
      offset: 0,
      companyId: safeCompanyId,
    },
    { skip: !isValid },
  );

  if (!isValid) {
    return <Navigate to={Paths.companies} replace />;
  }

  return (
    <MainLayout>
      {(data?.company && (
        <>
          <CompanyData company={data?.company} />
          <CompanyBilling company={data.company} />
          <CompanyTariffPlan company={data.company} />
          <CompanyIntegrationBindings company={data.company} />
          <CompanyStats companyId={companyId || ''} />
          <CompanyAccordion
            companyInvitations={data?.company?.companyInvitations || []}
            companyProfiles={data?.company?.companyProfiles || []}
            companyDeliveries={deliveriesData?.deliveries || []}
          />
        </>
      )) || (
        <Flex w={'100%'} justifyContent={'center'}>
          <Spinner size="xl" />
        </Flex>
      )}
    </MainLayout>
  );
};

export default Company;
